var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorjIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.5 28.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0052ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M22.75,0A22.78,22.78,0,0,1,44.66,28.91H40.32A18.61,18.61,0,1,0,4.14,22.75a18,18,0,0,0,.12,2.09H30.05a3.07,3.07,0,0,0,0-6.14H28.22L28,16.93a5.29,5.29,0,0,0-10.3-.72l-.43,1.49h-2a2.86,2.86,0,0,0-2.85,2.86v.14H8.21v-.14a7,7,0,0,1,6-6.92h.06l0-.07a9.44,9.44,0,0,1,8.34-5.28h.12a9.43,9.43,0,0,1,9,6.45v0l.1,0a7.22,7.22,0,0,1,5.48,6.88v.12a7.21,7.21,0,0,1-6.19,7.14H.84A22.78,22.78,0,0,1,22.75,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorjIcon);
export default __webpack_public_path__ + "static/media/storj-icon.e4ee755192e10ee8d824a46d4d04a403.svg";
export { ForwardRef as ReactComponent };